import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
	'pricing' : {
		'name': 'Pricing',
        'plans_text': 'PLAN',
        'choose_your_plan': 'Find the perfect plan to optimize your store',
        'most_popular_text': 'highly recommended',
        'buttons': {
            'you_are_here': 'You are here',
            'let_go': "Let's go",
            'let_start': "Let's start",
            'get_free': 'Get 14-days free',
            'switch_plan': 'Switch plan',
            'get_trial': 'Get {num}-day free trial',
            'downgrade': 'Downgrade',
            'upgrade': 'Upgrade',
            'maybe_later': 'Maybe later',
            'go_to_pricing': 'Go to Pricing',
            'approve_charge': 'Approve charge'
        },
		'menu':{
			'premium_plan':  'PREMIUM PLAN',
			'essential_plan': 'ESSENTIAL PLAN',
			'starter_plan': 'STARTER PLAN'
        },
        'switch': {
            'title': "Your store won't be as fast as before",
            'description': "<strong>Image</strong> and <strong>theme</strong> optimization aren't available in Free plan. Downgrade anyway?"
        },
        'free': {
            'name': 'Basic',
            'list_title': {
                'title_one': 'Smart Preloading using Google Analytics data',
                'title_two': 'Loading Screen with full customization',
                'title_three': 'Image optimization with Smart Lossy Compression',
                'title_four': 'Free 1000 images optimize per month',
                'title_five': 'Theme optimization',
                'title_six': 'Automatic optimization',
                'title_seven': 'Free store speed analysis and suggestions'
            }
        },
        'premium': {
            'name': 'Premium',
            'welcome_kit': 'Welcome kit',
            'free_trial': 'Get <span class=count-image-free>100 free images</span> today!',
            'list_title': {
                'title_one': 'Smart Preloading using Google Analytics data',
                'title_two': 'Loading Screen with full customization',
                'title_three': 'Image optimization with Smart Lossy Compression',
                'title_four': 'Free 1000 images optimize per month',
                'title_five': 'Theme optimization',
                'title_five_tooltip': 'We use these methods to optimize your theme:<br>'
                                    + '- Lazyload images<br>'
                                    + '- Minify CSS files<br>'
                                    + '- Minify Javascript files<br>'
                                    + '- Extract Critical CSS<br>'
                                    + '- Preload web fonts<br>',
                'title_six': 'Automatic optimization',
                'title_seven': 'Free store speed analysis and suggestions'
            }
        },
		'voucher': {
			'package': 'Package',
			'current_discount': 'Current discount',
			'total_payment': 'Total payment',
			'month': 'month',
			'your_discount_code': 'Your discount code',
			'input_your_code': 'Input your code',
			'accept': 'Accept'
        },
        'plan_notification': {
            'premium': {
                'title': 'Premium plan is now 50% off',
                'description': 'Thanks for being with us.<br>The new price will be applied after you approve charge.'
            },
            'perceived': {
                'title': 'Go Premium with no extra charge!',
                'description': "We've updated the pricing plan, now you can explore Premium features without additional charge!"
            },
            'actual': {
                'title': 'Go Premium with no extra charge!',
                'description': "We've updated the pricing plan, now you can explore Premium features without additional charge!"
            }
        }
	}
})